import { Component, Input } from '@angular/core';
import { ContentAnimDirective } from '../../product-layout/content-anim.directive';
import { NgStyle } from '@angular/common';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';
import { DefaultStyleDirective } from '../../../flex-layout/style';
import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { DefaultLayoutGapDirective } from '../../../flex-layout/custom-layout-gap';
import { EditorTextComponent } from '../editor-text/editor-text.component';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { environment } from '../../../../environments/environment';
import { DomSanitizer ,SafeHtml,SafeStyle } from '@angular/platform-browser';
import { CommonService } from '../../../services/common.service';
import { MobileIcon2Component } from './mobile-icon2/mobile-icon2.component';
import { LazyImgDirective } from '../../../shared/utils/directive/lazy-img.directive';
import { NgOptimizedImageComponent } from '../ng-optimized-image/ng-optimized-image.component';

@Component({
  selector: 'calsoft-mobileicon',
  imports: [ContentAnimDirective,NgOptimizedImageComponent, NgStyle, CustomFlexLayoutModule, DefaultStyleDirective, DefaultLayoutAlignDirective, MatIcon, DefaultLayoutDirective, MobileIcon2Component, LazyImgDirective, DefaultFlexDirective, EditorTextComponent, DefaultLayoutGapDirective, MatButton,],
  templateUrl: './mobileicon.component.html',
  styleUrl: './mobileicon.component.scss'
})
export class MobileiconComponent {

  
  public serverPath = environment.commonImageApi + '/home/';

  @Input() item: any;

  @Input() data: any;

  @Input() img: any;
  
  @Input() index: any;
  customField7: any;
  height: any;


  constructor(
    private sanitizer: DomSanitizer,
    private commonService: CommonService ) {}


    ngOnInit() {
    

    }
    sanitizeHtml(html: string): SafeHtml {
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }
  
    sanitizeStyle(style: string): SafeStyle {
      return this.sanitizer.bypassSecurityTrustStyle(style);
    }

  
  imageNavigation(id :any){


    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }

  }

  link(url:any) {

    this.commonService.goToLink(url)
  }


  openInNewWindow(url: string) {
    if (url) {
      this.commonService.goToLink(url)
    }
  }

  prependProtocol(url: string): string {
    if (!url.includes('http://') && !url.includes('https://')) {
      return 'https://' + url;
    }
    return url;
  }
}
